export enum CreatureType {
    Unknown,
    Zunnie,
    Sharkman,
    Oregon,
    Moonbits
}